import { Container, Row } from "reactstrap";
import LoginWithBgImageContainer from "../../Componant/Authentication/LoginWithBgImage";

const LoginWithBgImage = () => {
  return (
    <Container fluid>
      <Row>
        <LoginWithBgImageContainer />
      </Row>
    </Container>
  );
};

export default LoginWithBgImage;
